module.exports = __webpack_public_path__ + "img/img_historia.befd2341.webp";